import { Route } from 'react-router-dom'
import SetupScreen from 'screens/OnBoarding/SetupScreen'

const ONBOARDING_PATH = 'onboarding'
export const ONBOARDING = {
  INDEX: `${ONBOARDING_PATH}`,
  PREFERENCES: `/${ONBOARDING_PATH}/preferences`,
  RESIDENTS: `/${ONBOARDING_PATH}/residents`,
  INVITE: `/${ONBOARDING_PATH}/invite`,
  ACTIVATE: `/${ONBOARDING_PATH}/activate`
}

export const onBoardingRoutes = (
  <>
    <Route path={ONBOARDING.INDEX} element={<SetupScreen />} />,
    <Route path={ONBOARDING.PREFERENCES} element={<SetupScreen />} />
    ,
    <Route path={ONBOARDING.RESIDENTS} element={<SetupScreen />} />,
    <Route path={ONBOARDING.INVITE} element={<SetupScreen />} />,
    <Route path={ONBOARDING.ACTIVATE} element={<SetupScreen />} />,
  </>
)
